var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contest-offer-add-card"},[_c(_setup.BaseButtonV2,{staticClass:"contest-offer-add-card__add-button",attrs:{"variant":"primary","content-variant":"withIcon","text":"Добавить оффер","icon":_setup.SvgPlus,"is-disabled":_vm.disabled},on:{"click":function($event){return _setup.emit('start-add')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }